var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registrations-container"},[_c('RegistrationsSidebar',{attrs:{"current":_vm.company,"listMenu":_vm.changeSideBar()},on:{"changeTabMenuSideBar":(tab) => _vm.company = tab}}),_c('div',{staticClass:"registrations-main"},[_c('RegistrationsList',{attrs:{"company":_vm.company}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }